import {CSSProperties, ReactNode} from 'react';

import {reveal} from '../lib/styles';

export const Hero = ({
  actions,
  backgroundImage,
  hideImageLabel = false,
  imageLabel,
  kicker,
  copyTone = 'light',
  aside,
  subtitle,
  title,
  tone = 'blue'
}: {
  actions?: ReactNode;
  aside?: ReactNode;
  backgroundImage?: string;
  hideImageLabel?: boolean;
  imageLabel: string;
  kicker: string;
  copyTone?: 'light' | 'dark';
  subtitle: string;
  title: ReactNode;
  tone?: 'blue' | 'green' | 'gold' | 'slate' | 'violet' | 'cyan' | 'rose';
}) => (
  <section className={`nx-hero nx-hero-${tone} ${reveal} relative grid min-h-screen items-center overflow-hidden bg-[var(--nx-ink)] text-white max-[840px]:min-h-0`}>
    <div
      className={`${backgroundImage ? 'nx-hero-image nx-hero-image-art' : 'nx-hero-image'} absolute inset-0 overflow-hidden transition-[opacity,transform] duration-1000`}
      aria-label={imageLabel}
      role="img"
      style={backgroundImage ? ({'--nx-hero-art': `url(${backgroundImage})`} as CSSProperties) : undefined}
    >
      {hideImageLabel ? null : <span>{imageLabel}</span>}
    </div>
    <div className={`relative z-[1] grid items-center gap-[clamp(28px,5vw,72px)] px-[clamp(24px,8vw,120px)] py-[clamp(88px,13vw,180px)] max-[840px]:px-7 max-[840px]:pb-[72px] max-[840px]:pt-[110px] ${aside ? 'min-[1040px]:grid-cols-[minmax(0,1fr)_minmax(320px,440px)]' : ''}`}>
      <div className="nx-hero-copy max-w-[900px]">
        <p className={`mb-4 mt-0 text-[.84rem] font-extrabold uppercase ${copyTone === 'dark' ? 'text-[var(--nx-ink)]' : 'text-white/80'}`}>{kicker}</p>
        <h1 className={`mb-[26px] mt-0 max-w-[900px] text-[clamp(2.8rem,5.6vw,6rem)] leading-[.98] max-[840px]:text-[clamp(2.6rem,10vw,3.7rem)] ${copyTone === 'dark' ? 'text-[var(--nx-ink)]' : 'text-white'}`}>{title}</h1>
        <span className={`block max-w-[760px] text-[clamp(1.05rem,1.8vw,1.35rem)] leading-[1.7] ${copyTone === 'dark' ? 'text-[rgba(19,26,43,.76)]' : 'text-white/80'}`}>{subtitle}</span>
        {actions ? <div className="mt-[30px] flex flex-wrap gap-3">{actions}</div> : null}
      </div>
      {aside ? <div className="relative z-[1] w-full">{aside}</div> : null}
    </div>
  </section>
);
